import React from 'react';
import { useParams } from 'react-router-dom';
import ManagerTemperaturePreference from '../../ManagerTemperaturePreference';

function ManagerTemperaturePreferenceStore() {
  const params = useParams<{ storeId: string }>();
  const { storeId = '' } = params;
  return (
    <ManagerTemperaturePreference
      groupId={storeId}
      title="settings.temperature_preference.title_store"
      hintText="settings.temperature_preference.manager_store_hint"
    />
  );
}

export default ManagerTemperaturePreferenceStore;
